import {IconProps, Icon} from '@chakra-ui/react';

export function CrownIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M19.6251 7.22092C19.3221 6.97692 18.9021 6.93292 18.5531 7.10692L13.3811 9.69292L10.8581 5.48692C10.4971 4.88392 9.50408 4.88392 9.14308 5.48692L6.62008 9.69292L1.44708 7.10592C1.09808 6.93192 0.678077 6.97592 0.375077 7.21992C0.0700765 7.46592 -0.0639234 7.86392 0.0290766 8.24292L1.81808 15.3959C1.32408 15.7609 1.00008 16.3419 1.00008 17.0009V18.0009C1.00008 19.1039 1.89608 20.0009 3.00008 20.0009H17.0001C18.1041 20.0009 19.0001 19.1039 19.0001 18.0009V17.0009C19.0001 16.3419 18.6761 15.7609 18.1821 15.3969L19.9711 8.24392C20.0641 7.86392 19.9301 7.46592 19.6251 7.22092ZM6.55308 11.8959C7.02008 12.1289 7.58908 11.9639 7.85808 11.5159L10.0001 7.94392L12.1431 11.5149C12.4121 11.9629 12.9811 12.1279 13.4481 11.8949L17.5031 9.86792L16.2201 15.0009H3.78108L2.49808 9.86792L6.55308 11.8959ZM16.9971 18.0009H3.00008V17.0009H17.0001L16.9971 18.0009Z"
        fill="white"
      />
      <path
        d="M10 4.00098C11.1046 4.00098 12 3.10555 12 2.00098C12 0.896407 11.1046 0.000976562 10 0.000976562C8.89543 0.000976562 8 0.896407 8 2.00098C8 3.10555 8.89543 4.00098 10 4.00098Z"
        fill="white"
      />
    </Icon>
  );
}
